module.exports = __webpack_public_path__ + "img/title-dver-2-m@2x.8c7da5d5.png";